import React, { useEffect, useState } from 'react';
import Modal from './Modal';
import { registerDialogListener } from '../utils/dialogService';

const DEFAULT_TITLES = {
  alert: 'Hinweis',
  confirm: 'Bestätigung erforderlich',
  prompt: 'Eingabe',
};

/**
 * Rendert die Dialoge aus utils/dialogService.js. Wird einmal an der Wurzel
 * der App gemountet (siehe App.js), damit Dialoge unabhängig vom Lebenszyklus
 * des aufrufenden Modals sichtbar bleiben.
 */
function DialogHost() {
  const [dialog, setDialog] = useState(null);
  const [promptValue, setPromptValue] = useState('');

  useEffect(() => {
    return registerDialogListener((d) => {
      setPromptValue(d.defaultValue ?? '');
      setDialog(d);
    });
  }, []);

  if (!dialog) return null;

  const { type, message, title, variant, resolve } = dialog;
  const danger = variant === 'danger';
  const cancelResult = type === 'confirm' ? false : type === 'prompt' ? null : undefined;

  const close = (result) => {
    setDialog(null);
    resolve(result);
  };

  return (
    <Modal show onHide={() => close(cancelResult)} size="sm" variant={variant}>
      <Modal.Header onClose={() => close(cancelResult)}>
        {title ?? DEFAULT_TITLES[type]}
      </Modal.Header>
      <Modal.Body>
        <p className="text-sm text-slate-700 whitespace-pre-line">{message}</p>
        {type === 'prompt' && (
          <input
            type="text"
            className="input w-full mt-3"
            value={promptValue}
            onChange={(e) => setPromptValue(e.target.value)}
            autoFocus
            onFocus={(e) => e.target.select()}
            onKeyDown={(e) => { if (e.key === 'Enter') close(promptValue); }}
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        {type === 'alert' && (
          <button className="btn btn-primary" onClick={() => close(undefined)} autoFocus>OK</button>
        )}
        {type === 'confirm' && (
          <>
            <button className="btn-secondary btn" onClick={() => close(false)}>Abbrechen</button>
            <button className={`btn ${danger ? 'btn-danger' : 'btn-primary'}`} onClick={() => close(true)} autoFocus>OK</button>
          </>
        )}
        {type === 'prompt' && (
          <>
            <button className="btn-secondary btn" onClick={() => close(null)}>Abbrechen</button>
            <button className="btn btn-primary" onClick={() => close(promptValue)}>OK</button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
}

export default DialogHost;
